import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class LayoutService {
    private _displayLangue: BehaviorSubject<boolean> = new BehaviorSubject(false);

    public readonly displayLangue: Observable<boolean> = this._displayLangue.asObservable();

    public initLayout(display: boolean) {
        this._displayLangue.next(display);
    }
}
